import { Component, OnInit, Input } from '@angular/core';
import { FormControl, ValidatorFn, AbstractControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-password-verification',
  templateUrl: './password-verification.component.html',
  styleUrls: ['./password-verification.component.scss']
})
export class PasswordVerificationComponent implements OnInit {
    @Input() password: FormControl;
    @Input() confirmPassword: FormControl;
    @Input() required: boolean = false;
    @Input() withConfirmation: boolean = true;

    public showToolTips: boolean = false;
    public minLowerVerified: boolean = false;
    public minUpperVerified: boolean = false;
    public minNumericVerified: boolean = false;
    public minSymbolVerified: boolean = false;
    public minLengthVerified: boolean = false;

    private lowerPattern: string = `^(?=(.*[a-z]){1}).*$`;
    private upperPattern: string = `^(?=(.*[A-Z]){1}).*$`;
    private numericPattern: string = `^(?=(.*[0-9]){1}).*$`;
    private symbolPattern: string = "^(?=(.*[~,`,!,@@,#,$,%,^,&,*,(,),+,=,{,},:,;,<,>,?,/,']){1}).*$";
    private lengthPattern: string = `^(?=^.{6,}$)`;

    constructor() { }

    ngOnInit() {
        this.password.valueChanges.subscribe((val: string) => {
            if (this.withConfirmation) {
                if (val) {
                    this.confirmPassword.setValidators([Validators.required, this.comparePassword(val)]);
                    this.confirmPassword.updateValueAndValidity({onlySelf: true});
                } else {
                    this.confirmPassword.clearValidators();
                }
            }
            this.minLowerVerified = val && val.match(this.lowerPattern) ? true : false;
            this.minUpperVerified = val && val.match(this.upperPattern) ? true : false;
            this.minNumericVerified = val && val.match(this.numericPattern) ? true : false;
            this.minSymbolVerified = val && val.match(this.symbolPattern) ? true : false;
            this.minLengthVerified = val && val.match(this.lengthPattern) ? true : false; 
        });

        if (this.required) {
            this.password.setValidators([Validators.required, this.validatePassword()]);
        } else {
            this.password.setValidators(this.validatePassword());
        }
    }

    private validatePassword = (): ValidatorFn => {
        return (control: AbstractControl): {[key: string]: any} | null => {
            var pattern = new RegExp(/^(?=.*[a-z]{1})(?=.*[A-Z]{1})(?=.*[0-9]{1})(?=.*[~,`,!,@@,#,$,%,^,&,*,(,),+,=,{,},:,;,<,>,?,/,'])(?=^.{6,}).*$/g);
            const validate: boolean = control.value && control.value.length ? true : false;
            if (validate) {
                return pattern.test(control.value) ? null : {'invalidPassword': true};
            }
            return null;
        };
    }

    private comparePassword = (password: string): ValidatorFn => {
        return (control: AbstractControl): {[key: string]: any} | null => {
            return control.value === password ? null : {'passwordsDontMatch': true};
        };
    }

    public onFocus = () => {
        this.showToolTips = true;
    }

    public onFocusOut = () => {
        this.showToolTips = false;
    }

}
